import React from 'react'
import Popup from '../components/Popup'

const TestRange = () => {
  return (
    <Popup title={'TEST RANGE'} message={'Do you want to join test range?'} />
  )
}

export default TestRange
